import { faSpinnerThird } from '@fortawesome/pro-duotone-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

export function LoadingPageMobile() {
  const { t } = useTranslation();
  return (
    <div className="absolute inset-0 flex flex-col gap-4 items-center text-sm justify-center">
      <FontAwesomeIcon
        icon={faSpinnerThird}
        size="4x"
        spin
        className="text-primary-blue-600"
        style={
          {
            '--fa-secondary-color': '#D1D1D6',
            '--fa-secondary-opacity': 1,
          } as React.CSSProperties
        }
      />
      <div className="text-neutrals-900 text-sm">{t('actions.loading')}</div>
    </div>
  );
}
